import React from 'react';
import ReactDOM from 'react-dom';
import Cookies from 'js-cookie';
import App from './App';

if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
  Cookies.set(
    'SMARTTOKEN',
    'CQAAFwdAAAQVjJxR2BpDEMdexd1XV8rEFRgXkEfLlsPdKgGRM1EjbotBjBjLImQ__cAAAfnfuEWbzuRVLUFsWt51DHYbzORrJwqIZLLAAABJNRSOQ1gAA_RgAAI-qZi-',
  );
}

ReactDOM.render(<App />, document.getElementById('smart-root'));
